module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "jumbo jumbo-a"
  }, [_c('div', {
    staticClass: "jumbo-content"
  }, [_c('h2', {
    staticClass: "text-uppercase"
  }, [_vm._v("Website Development")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default btn-lg text-uppercase",
    attrs: {
      "to": "website-development"
    }
  }, [_vm._v("Read more")]), _vm._v(" "), _c('p', [_vm._v("We provide customized web-based solutions tailored to the client’s specific business requirements using the latest technologies and industry trends.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jumbo jumbo-b"
  }, [_c('div', {
    staticClass: "jumbo-content"
  }, [_c('h2', {
    staticClass: "text-uppercase"
  }, [_vm._v("Front-End Outsourcing")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default btn-lg text-uppercase",
    attrs: {
      "to": "front-end-outsourcing"
    }
  }, [_vm._v("Read more")]), _vm._v(" "), _c('p', [_vm._v("While you focus on your core business process, our expert web developers will maximize your ability to deliver high quality product and speed up time-to-market.")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-156c5a20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/home.vue
// module id = 47
// module chunks = 1